import { getMainVideo } from "./video";

/**
 * @method
 * @param { Object } collection collection with recipes
 * @returns { Object } with steps and videos flags to show or not steps and videos infos for collection
 */
export default function checkCollectionDirections(recipes) {
  let hasVideos = false;
  let hasImages = false;

  for (const recipe of recipes) {
    hasVideos = hasVideos ? hasVideos : !!getMainVideo(recipe);
  }

  const element_directions = recipes.reduce((acc, val) => [...acc, ...val.element_direction], []);
  const directions = element_directions.reduce((acc, val) => [...acc, ...val.direction], []);
  for (const direction of directions) {
    hasImages = hasImages ? hasImages : !!direction.main_image || !!getMainVideo(direction);
  }

  return {
    steps: hasImages,
    videos: hasVideos,
  };
}

export const getAllIngredients = (recipe) => {
  const ingredientsObjs = recipe.element_ingredient.reduce((acc, val) => [...acc, ...val.ingredient], []);
  const ingredients = ingredientsObjs.map((ing) => ing.ingredient);

  return ingredients;
};

export const getStepsForSeo = (recipe) => {
  const element_directions = recipe.element_direction.reduce((acc, val) => {
    const dirctionsWithName = val.direction.map((dir) => ({ ...dir, name: val.name }));
    return [...acc, dirctionsWithName];
  }, []);

  return element_directions;
};

export const getValidatedPageTitle = (title, creatorName) => {
  let objTitle = title;
  let combinedTitle = `${objTitle} | ${creatorName} | Foody`;
  if (combinedTitle.length > 60) {
    let deletelength = title.length - (combinedTitle.length - 60);
    let trimmedString = objTitle.substring(0, deletelength + 1);
    combinedTitle = `${trimmedString} | ${creatorName} | Foody`;
  }
  return combinedTitle;
};
